import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CheckInEventService {
  private ticketCheckedInSubject = new Subject<void>();
  public ticketCheckedIn$ = this.ticketCheckedInSubject.asObservable();

  private openDialogSubject = new Subject<void>();
  public openDialog$ = this.openDialogSubject.asObservable();

  notifyTicketCheckedIn(): void {
    this.ticketCheckedInSubject.next();
  }

  notifyOpenDialog(): void {
    this.openDialogSubject.next();
  }
}
